import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=7d4b4cfa&scoped=true&"
import script from "./auction.vue?vue&type=script&lang=js&"
export * from "./auction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b4cfa",
  null
  
)

export default component.exports